(function () {
  if (window.UqoraPriceTestCollections) return;

  const SELECTOR = '.price[data-price-test-eligible="true"]';
  const STRIKE_CLASS = "price-test-original-price";
  const SAVINGS_SELECTOR = ".savings-message";
  const SAVINGS_PATTERN = /(\d+(?:\.\d+)?)\s*%/;

  const formatMoney = (value) => {
    const rounded = Math.round((value + Number.EPSILON) * 100) / 100;
    return Number.isInteger(rounded) ? rounded.toFixed(0) : rounded.toFixed(2);
  };

  // The card "Save N%" tag is a merchant-typed number with no stored base, so
  // rescale it from the price it was written for: the implied reference price
  // is original / (1 - N%), and the treatment tag is the discounted price's
  // savings against that same reference.
  const rescaleSavings = (basePct, originalAmount, discounted) => {
    if (!(basePct > 0 && basePct < 100)) return null;
    const reference = originalAmount / (1 - basePct / 100);
    return Math.round((1 - discounted / reference) * 100);
  };

  // Restores the server-rendered markup (captured once, on first pass) before
  // deciding whether to re-apply a discount. Makes every call idempotent:
  // safe to run repeatedly on cart mutations, and correctly reverts if
  // price-test flips from enabled to disabled mid-session.
  const restoreOriginal = (priceEl, regularEl, savingsEl) => {
    // Hide markup injected by an earlier script version during hot reloads.
    const strike = priceEl.querySelector(`.${STRIKE_CLASS}`);
    if (strike) strike.hidden = true;

    if (priceEl.dataset.priceTestOriginalHtml === undefined) {
      priceEl.dataset.priceTestOriginalHtml = regularEl.innerHTML;
    } else {
      regularEl.innerHTML = priceEl.dataset.priceTestOriginalHtml;
    }

    if (!savingsEl) return;
    if (priceEl.dataset.priceTestOriginalSavings === undefined) {
      priceEl.dataset.priceTestOriginalSavings = savingsEl.textContent;
    } else {
      savingsEl.textContent = priceEl.dataset.priceTestOriginalSavings;
    }
  };

  const applyToElement = (priceEl) => {
    const variantId = priceEl.getAttribute("data-price-test-variant-id");
    const purchaseType = priceEl.getAttribute("data-price-test-purchase-type");
    const originalAmount = parseFloat(
      priceEl.getAttribute("data-price-test-original-amount")
    );
    const regularEl = priceEl.querySelector(".price-item--regular");
    const savingsEl = priceEl.querySelector(SAVINGS_SELECTOR);
    if (!variantId || !regularEl || Number.isNaN(originalAmount)) return;

    restoreOriginal(priceEl, regularEl, savingsEl);

    if (!window.UqoraPriceTest || !window.UqoraPriceTest.enabled()) return;

    const isSubscription = purchaseType === "subscription";
    const amountOffCents = window.UqoraPriceTest.amountFor(variantId, isSubscription);
    if (!(amountOffCents > 0)) return;

    const discounted = originalAmount - amountOffCents / 100;
    if (discounted < 0) return;

    const labelEl = regularEl.querySelector(".starts-at-label");
    regularEl.textContent = "";
    if (labelEl) regularEl.appendChild(labelEl);
    regularEl.appendChild(
      document.createTextNode((labelEl ? " " : "") + `$${formatMoney(discounted)}`)
    );

    if (savingsEl) {
      const originalSavings = priceEl.dataset.priceTestOriginalSavings;
      const match = originalSavings.match(SAVINGS_PATTERN);
      const pct = match && rescaleSavings(parseFloat(match[1]), originalAmount, discounted);
      if (pct > 0) {
        savingsEl.textContent = originalSavings.replace(SAVINGS_PATTERN, `${pct}%`);
      }
    }
  };

  const applyAll = () => {
    document.querySelectorAll(SELECTOR).forEach(applyToElement);
  };

  const init = () => {
    if (!window.UqoraPriceTest) return;
    window.UqoraPriceTest.ready.then(applyAll);
    window.addEventListener(window.UqoraPriceTest.events.updated, applyAll);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-scan when a quick-add bulk modal (duplicate price markup) connects
  // after initial load.
  document.addEventListener("MultiProductSubscriptions:connected", applyAll);

  window.UqoraPriceTestCollections = { applyAll };
})();
